module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users/user-detail/user-detail.component.css
// module id = ./src/app/components/users/user-detail/user-detail.component.css
// module chunks = main